module.exports = __webpack_public_path__ + "static/media/Badge_SvgAppBienvenue_disabled.22e5401b.svg";